import React from 'react'
import {Color} from '../../Styles'
import styled from '@emotion/styled'
import {MemberCircleExclamationIcon} from './Bases/MemberCircleExclamationIcon'
import AttentionBorderColor = Color.AttentionBorderColor

const IconBlock = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
  margin-right: 8px;
`

const BlackCircle = styled.div`
  background-color: ${Color.Black};
  border-radius: 50%;
  width: 15px;
  height: 15px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
`

const IconPosition = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

export const MemberAttentionExclamationIcon: React.VFC = () => {
  return <IconBlock>
    <BlackCircle/>
    <IconPosition>
      <MemberCircleExclamationIcon color={AttentionBorderColor} size={'xl'}/>
    </IconPosition>
  </IconBlock>
}
